import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import brandsReducer from "./slices/brandsSlice";
import categoriesReducer from "./slices/categoriesSlice.js";
import productsReducer from "./slices/productsSlice";
import ordersReducer from "./slices/ordersSlice";
import usersReducer from "./slices/usersSlice";
import cartReducer from "./slices/cartSlice";

import { combineReducers } from "redux";

const rootReducer = combineReducers({
  Brand: brandsReducer,
  Category: categoriesReducer,
  Product: productsReducer,
  Order: ordersReducer,
  User: usersReducer,
  Cart: cartReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["User", "Cart"], // solo lo importante
};

const persistedReducer = persistReducer(
  persistConfig,
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

